import User from './User';
import UserRole from './UserRole';

export class ForumThreadUser extends User {
  static get entity() {
    return 'forum_thread_users';
  }

  static get fk() {
    return 'user_id';
  }

  static fields() {
    return {
      ...User.fields()
    };
  }

  static apiConfig = {
    actions: {
      ...User.apiConfig?.actions
    }
  };

  get forumRole() {
    if (this.user_roles.length) {
      if (this.user_roles.some((role) => role.role === UserRole.DESIGNER)) {
        return 'Expert';
      }
      if (this.user_roles.some((role) => role.role === UserRole.LEARNER)) {
        return 'Learner';
      }
    }

    return null;
  }
}

export default ForumThreadUser;
